/**
 * @fileoverview GET handler for the "/apps/:app_group_id/user_imports_datatable" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appsAppGroupIdUserImportsDatatable } from "./constants";
import type { AppsAppGroupIdUserImportsDatatableParams, AppsAppGroupIdUserImportsDatatableResult } from "./types";

export const getUserImportsDatatable = reactQueryTableFetcherAdapter(
  appsAppGroupIdUserImportsDatatable,
  (
    signal: AbortSignal,
    { appGroupId, limit = 20, start = 0 }: AppsAppGroupIdUserImportsDatatableParams
  ): Promise<AppsAppGroupIdUserImportsDatatableResult> => {
    return fetch(
      `/apps/${appGroupId}/user_imports_datatable`,
      "GET",
      {
        limit,
        start,
        app_group_id: appGroupId,
      },
      { signal }
    );
  }
);
